import BaseHelper from './base-helper';
import API_MAP from '../configs/url-api';

class ReferenceBooksApi extends BaseHelper {
  getReferenceBooks() {
    return this.request(API_MAP.REFERENCE_BOOKS, {
      method: 'GET',
      auth: 'Bearer',
    });
  }

  getReferenceBooksByKey(key) {
    return this.request(`${API_MAP.REFERENCE_BOOKS}/${key}`, {
      method: 'GET',
      auth: 'Bearer',
    });
  }
}

export default new ReferenceBooksApi();
